// © Microsoft Corporation. All rights reserved.

import { enums } from "./enums";

export function getReactionColorClass (reaction: string) {
    if (!reaction) { return ""; }
    return (reaction === enums.reactions.love || reaction === enums.reactions.angry) ?
        "cwt-red-reaction" : "cwt-yellow-reaction";
}
